import { FieldSlugEnum } from 'common/enums/FieldSlugEnum'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockId } from 'src/shared/types/base-entity-interface'
import { RecaptchaInterface } from 'common/types/entities/RecaptchaInterface'
import { generateBaseEntity } from '../utils/generate-base-entity'

export function createRecaptcha(
  type: EntityTypeEnum.OptInRecaptcha | EntityTypeEnum.ContactUsRecaptcha,
  parentId: string,
  masterBlockId?: MasterBlockId,
): RecaptchaInterface {
  const recaptcha: RecaptchaInterface = {
    ...generateBaseEntity(type, parentId, masterBlockId),
    parentId,
    slug: FieldSlugEnum.Recaptcha,
    theme: 'light',
    alignSelf: 'flex-start',
  }

  return recaptcha
}
